import { render, staticRenderFns } from "./ScatterVis.vue?vue&type=template&id=076a5454&scoped=true&"
import script from "./ScatterVis.vue?vue&type=script&lang=js&"
export * from "./ScatterVis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076a5454",
  null
  
)

export default component.exports